// src/utils/useFieldSetter.js
import { useCallback } from "react";

/**
 * Single-page form pattern (see CLAUDE.md "Form patterns"): a curried setter
 * that updates one field of a form object and, if that field had an error,
 * clears it so the user sees feedback only after re-validation.
 *
 *   const update = useFieldSetter(setForm, errors, setErrors);
 *   <TextField value={form.foo} onChange={update("foo")} />
 *
 * Skip this helper for setters that need extra per-field logic (trimming,
 * checkbox branching, side effects) — open-code those.
 */
export function useFieldSetter(setForm, errors, setErrors) {
    return useCallback((key) => (e) => {
        const value = e?.target?.value;
        setForm((f) => ({ ...f, [key]: value }));
        if (errors[key]) {
            setErrors((prev) => {
                const next = { ...prev };
                delete next[key];
                return next;
            });
        }
    }, [setForm, errors, setErrors]);
}
